export default {
  header: "Sorry, we couldn't find that page.",
  subheader:
    "Please check the URL and try again, or see below for contact information.",
};
